(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("binaryen"));
	else if(typeof define === 'function' && define.amd)
		define(["binaryen"], factory);
	else if(typeof exports === 'object')
		exports["asc"] = factory(require("binaryen"));
	else
		root["asc"] = factory(root["binaryen"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__11__) {
return 